import { all, put, takeLatest } from "redux-saga/effects";
import BundleOrderService from "../../services/BundleOrderService";
import NotesService from "../../services/NotesService";
import {
  componentKey,
  getClinicLocationData,
  getPatientListData,
  getSearchedPatientList,
  appendSearchedPatientList,
  setSearchedPatientTotalPages,
  getViewPatientProfileData,
  setCloseChiefComplaintDialog,
  setCloseCreateOrderDialog,
  setCloseCreatePatientDrawer,
  setCloseCreateTriageDrawer,
  setCloseCreateVisitDrawer,
  setCloseDispositionDialog,
  setCloseEditProfileDialog,
  setCloseEmergencyContactDialog,
  setCloseBaseCampDialog,
  setCloseEMSSceneVisit,
  setCloseVerifyOrderStatus,
  setCreateVisitDataForTriage,
  setDataForEmergencyContactTab,
  setDepartmentData,
  setDispositionData,
  setFacilityData,
  setRoomList,
  setIncidentLocationData,
  setFacilityList,
  setMasterCodeData,
  setOpenCreateVisitForceFullyDialog,
  setOrderChange,
  setPatientIdFromParticipant,
  setRefreshPatientList,
  setTableDataForOrderTab,
  setTableDataForVisitTab,
  setTempVisitData,
  setUpdateVisitNoteDataOnceDraftNote,
  setVisitNoteCareFlowData,
  setVisitNoteCareFlowDataForDischargePreview,
  setVisitPreviewDialog,
  setTableDataForDocumentsTab,
  setCloseUploadDocumentDialog,
} from "./patientSlice";
import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import PatientListService from "../../services/PatientListService";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import { setClosePreviewDialog } from "../dashboard-screen/dashboardSlice";

export const {
  getPatientList,
  createNewVisit,
  searchParticipants,
  createNewPatient,
  getClinicLocations,
  convertParticipantToPatient,
  getPatientProfileData,
  patchPatientProfileDetailsData,
  createTriage,
  getPatientDetailsDataByTabWise,
  getVisitNoteById,
  patchEmergencyContactData,
  patchBaseCampData,
  patchChiefComplaintData,
  getAllMasterCode,
  postVisitNoteData,
  patchVisitNoteData,
  sendVisitNote,
  postOrderData,
  postTransferPatient,
  postBundleOrder,
  getDepartments,
  updateDispositionData,
  deleteOrderItem,
  getFacilities,
  getRoomList,
  assignRoom,
  getIncidentLocations,
  patchVerifyOrder,
  patchPatient,
  convertPartToPatient,
  createEMSVisit,
  postTransferEMSPatient,
  postDataToJotForm,
  getFacilityList,
  sendEmail,
  sendSMS,
  getVisitNoteByIdForPreviewDischargeForm,
  getAllOrderNotes,
  getOrderNoteById,
  createOrderNote,
  updateOrderNote,
  deleteOrderNote,
  getPatientDocuments,
  uploadPatientDocument,
  deletePatientDocument,
  deleteVisit,
} = {
  searchParticipants: (payload) => {
    return {
      type: "PATIENT/SEARCH",
      payload,
    };
  },
  createNewPatient: (payload) => {
    return {
      type: "PATIENT/CREATE_NEW_PATIENT",
      payload,
    };
  },
  getPatientList: (payload) => {
    return {
      type: "PATIENT/GET_PATIENT_LIST",
      payload,
    };
  },

  createNewVisit: (payload) => {
    return {
      type: "PATIENT/CREATE_NEW_VISIT",
      payload,
    };
  },

  createEMSVisit: (payload) => {
    return {
      type: "PATIENT/CREATE_EMS_VISIT",
      payload,
    };
  },

  getClinicLocations: (payload) => {
    return {
      type: "PATIENT/GET_CLINIC_LOCATIONS",
      payload,
    };
  },
  convertParticipantToPatient: (payload) => {
    return {
      type: "PATIENT/CONVERT_PARTICIPANT_TO_PATIENT",
      payload,
    };
  },

  convertPartToPatient: (payload) => {
    return {
      type: "PATIENT/CONVERT_PART_TO_PATIENT",
      payload,
    };
  },

  getPatientProfileData: (payload) => {
    return {
      type: "PATIENT/GET_PATIENT_PROFILE_DATA",
      payload,
    };
  },
  patchPatientProfileDetailsData: (payload) => {
    return {
      type: "PATIENT/PATCH_PATIENT_PROFILE_DETAILS_DATA",
      payload,
    };
  },
  createTriage: (payload) => {
    return {
      type: "PATIENT/CREATE_TRIAGE",
      payload,
    };
  },
  getPatientDetailsDataByTabWise: (payload) => {
    return {
      type: "PATIENT/PATIENT_DETAILS_TAB_WISE_VIEW",
      payload,
    };
  },

  getVisitNoteById: (payload) => {
    return {
      type: "PATIENT/GET_VISIT_NOTE_BY_ID",
      payload,
    };
  },

  patchEmergencyContactData: (payload) => {
    return {
      type: "PATIENT/PATCH_EMERGENCY_CONTACT_DATA",
      payload,
    };
  },
  patchBaseCampData: (payload) => {
    return {
      type: "PATIENT/PATCH_BASE_CAMP_DATA",
      payload,
    };
  },
  patchChiefComplaintData: (payload) => {
    return {
      type: "PATIENT/PATCH_CHIEF_COMPLAINT_DATA",
      payload,
    };
  },
  getAllMasterCode: (payload) => {
    return {
      type: "PATIENT/GET_ALL_MASTER_CODE",
      payload,
    };
  },
  postVisitNoteData: (payload) => {
    return {
      type: "PATIENT/POST_VISIT_NOTE_DATA",
      payload,
    };
  },
  patchVisitNoteData: (payload) => {
    return {
      type: "PATIENT/PATCH_VISIT_NOTE_DATA",
      payload,
    };
  },
  sendVisitNote: (payload) => {
    return {
      type: "PATIENT/SEND_VISIT_NOTE",
      payload,
    };
  },
  postOrderData: (payload) => {
    return {
      type: "PATIENT/POST_ORDER_DATA",
      payload,
    };
  },
  postTransferPatient: (payload) => {
    return {
      type: "PATIENT/POST_TRANSFER_PATIENT",
      payload,
    };
  },
  postBundleOrder: (payload) => {
    return {
      type: "PATIENT/POST_BUNDLE_ORDER",
      payload,
    };
  },
  postTransferEMSPatient: (payload) => {
    return {
      type: "PATIENT/POST_EMS_TRANSFER_PATIENT",
      payload,
    };
  },
  getDepartments: (payload) => {
    return {
      type: "PATIENT/GET_DEPARTMENTS",
      payload,
    };
  },
  updateDispositionData: (payload) => {
    return {
      type: "PATIENT/UPDATE_DISPOSITION_DATA",
      payload,
    };
  },

  deleteOrderItem: (payload) => {
    return {
      type: "PATIENT/DELETE_ORDER_ITEM",
      payload,
    };
  },
  getFacilities: (payload) => {
    return {
      type: "PATIENT/GET_FACILITIES",
      payload,
    };
  },
  getRoomList: (payload) => {
    return {
      type: "PATIENT/GET_ROOM_LIST",
      payload,
    };
  },
  assignRoom: (payload) => {
    return {
      type: "PATIENT/ASSIGN_ROOM",
      payload,
    };
  },
  getIncidentLocations: (payload) => {
    return {
      type: "PATIENT/GET_INCIDENT_LOCATIONS",
      payload,
    };
  },
  patchVerifyOrder: (payload) => {
    return {
      type: "PATIENT/PATCH_VERIFY_ORDER_STATUS",
      payload,
    };
  },
  patchPatient: (payload) => {
    return {
      type: "PATIENT/PATCH_PATIENT",
      payload,
    };
  },
  postDataToJotForm: (payload) => {
    return {
      type: "PATIENT/POST_DATA_TO_JOT_FORM",
      payload,
    };
  },
  getFacilityList: (payload) => {
    return {
      type: "PATIENT/FACILITY/GET_FACILITY_LIST",
      payload,
    };
  },
  sendEmail: (payload) => {
    return {
      type: "PATIENT/SEND_EMAIL",
      payload,
    };
  },
  sendSMS: (payload) => {
    return {
      type: "PATIENT/SEND_SMS",
      payload,
    };
  },
  getVisitNoteByIdForPreviewDischargeForm: (payload) => {
    return {
      type: "PATIENT/GET_VISIT_NOTE_BY_ID_FOR_PREVIEW_DISCHARGE_FORM",
      payload,
    };
  },
  getAllOrderNotes: (payload) => {
    return {
      type: "PATIENT/GET_ALL_ORDER_NOTES",
      payload,
    };
  },
  getOrderNoteById: (payload) => {
    return {
      type: "PATIENT/GET_ORDER_NOTE_BY_ID",
      payload,
    };
  },
  createOrderNote: (payload) => {
    return {
      type: "PATIENT/CREATE_ORDER_NOTE",
      payload,
    };
  },
  updateOrderNote: (payload) => {
    return {
      type: "PATIENT/UPDATE_ORDER_NOTE",
      payload,
    };
  },
  deleteOrderNote: (payload) => {
    return {
      type: "PATIENT/DELETE_ORDER_NOTE",
      payload,
    };
  },
  getPatientDocuments: (payload) => {
    return {
      type: "PATIENT/GET_PATIENT_DOCUMENTS",
      payload,
    };
  },
  uploadPatientDocument: (payload) => {
    return {
      type: "PATIENT/UPLOAD_PATIENT_DOCUMENT",
      payload,
    };
  },
  deletePatientDocument: (payload) => {
    return {
      type: "PATIENT/DELETE_PATIENT_DOCUMENT",
      payload,
    };
  },
  deleteVisit: (payload) => {
    return {
      type: "PATIENT/DELETE_VISIT",
      payload,
    };
  },
};

// SEARCH PARTICIPANT API CALL FUNCTION
function* searchParticipantsAsync(action) {
  const pageNumber = action?.payload?.pageNumber ?? 1;
  const limit = action?.payload?.limit ?? 10;
  const isFirstPage = pageNumber === 1;
  try {
    // Only show the loader on the first page so infinite-scroll loads don't flicker.
    if (isFirstPage) yield put(showLoader());

    const response = yield PatientListService.getParticipantsBySearch(
      action?.payload?.searchKey,
      pageNumber,
      limit
    );
    const { status } = response;
    if (status) {
      const { participant, totalPages } = response?.data;
      const list = participant ?? [];
      yield put(setSearchedPatientTotalPages(totalPages ?? 1));
      yield put(
        isFirstPage
          ? getSearchedPatientList(list)
          : appendSearchedPatientList(list)
      );
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    if (isFirstPage) yield put(hideLoader());
  }
}

// CREATE NEW PATIENT API CALL FUNCTION
function* createNewPatientAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.createNewPatient(
      action.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const { message, patient } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseCreatePatientDrawer(true));
      action?.payload?.navigate(`/patient/${patient?.id}`);
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseCreatePatientDrawer(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// SEARCH PARTICIPANT API CALL FUNCTION
function* getPatientListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.getPatientList(action?.payload);
    const { status } = response;
    if (status) {
      const { data } = response;
      yield put(getPatientListData(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// CREATE VISIT API CALL FUNCTION
function* createNewVisitAsync(action) {
  const { apIPayload, force } = action.payload;
  try {
    yield put(showLoader());
    const response = yield PatientListService.createNewVisit(apIPayload, force);
    const { status } = response;

    if (status) {
      const { message, visit } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseCreateVisitDrawer(true));
      yield put(
        setCreateVisitDataForTriage({
          visitId: visit?.id,
          patientId: visit?.patientId,
          typeOfCare: visit?.typeOfCare,
        })
      );
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    const { status } = error?.response;
    if (status === 409) {
      yield put(setOpenCreateVisitForceFullyDialog(true));
    }

    yield put(setCloseCreateVisitDrawer(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// CREATE EMS VISIT API CALL FUNCTION
function* createEMSVisitAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.createEMSVisit(action.payload);
    const { status } = response;

    if (status) {
      const { message, emsVisit } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setTempVisitData(emsVisit));
      yield put(setCloseEMSSceneVisit(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setTempVisitData({}));
    yield put(setCloseEMSSceneVisit(false));

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET CLINIC LOCATIONS API CALL FUNCTION
function* getClinicLocationsAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.getClinicLocations();
    const { status } = response;
    if (status) {
      const { basecamp } = response?.data;
      yield put(getClinicLocationData(basecamp));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// CONVERT PARTICIPANT TO PATIENT API CALL FUNCTION
function* convertParticipantToPatientAsync(action) {
  const { payload, navigate, comesFrom } = action.payload;
  try {
    yield put(showLoader());
    const response =
      yield PatientListService.convertParticipantToPatient(payload);
    const { status } = response;
    if (status) {
      const { id } = response?.data;
      if (comesFrom === "createVisitFromSearchParticipantCard") {
        yield put(setCloseCreatePatientDrawer(true));
        navigate(`/patient/${id}`);
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseCreatePatientDrawer(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// CONVERT PARTICIPANT TO PATIENT API CALL FUNCTION
function* convertPartToPatientAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.convertPartToPatient(
      action.payload
    );
    const { status, data } = response;
    if (status) {
      yield put(setPatientIdFromParticipant(data?.data?.id));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setPatientIdFromParticipant(""));

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET PATIENT PROFILE DATA API CALL HERE
function* getPatientProfileDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.getPatientProfileData(
      action?.payload
    );
    const { status } = response;
    if (status) {
      const { data } = response?.data;
      yield put(getViewPatientProfileData(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH PATIENT PROFILE DETAILS DATA API CALL HERE
function* patchPatientProfileDetailsDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.patchPatientProfileDetailsData(
      action?.payload?.patientId,
      action?.payload?.payload
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseEditProfileDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseEditProfileDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// CREATE NEW PATIENT API CALL FUNCTION
function* createTriageAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.createTriage(
      action?.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const { message, patient } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });

      if (
        action?.payload?.comesFrom === "patientScreen" ||
        action?.payload?.comesFrom === "dashboard"
      ) {
        yield put(setCloseCreateTriageDrawer(true));
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseCreateTriageDrawer(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// CONVERT PARTICIPANT TO PATIENT API CALL FUNCTION
function* getPatientDetailsDataByTabWiseAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.getPatientDetailsDataByTabWise(
      action?.payload?.apiQuery
    );
    const { status } = response;
    if (status) {
      const { data } = response?.data;
      if (action?.payload?.selectedTab === "visits") {
        yield put(setTableDataForVisitTab(response?.data));
      } else if (action?.payload?.selectedTab === "orders") {
        yield put(setTableDataForOrderTab(response?.data));
      } else if (action?.payload?.selectedTab === "eCI") {
        yield put(setDataForEmergencyContactTab(data));
      } else if (action?.payload?.selectedTab === "healthHistory") {
        window?.open(response?.data?.sso?.url, "_blank"); // Opens in a new tab

        setTimeout(() => {
          window?.open(response?.data?.patientUrl, "_blank"); // Opens in a new tab
        }, 300);
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* getVisitNoteByIdAsync(action) {
  const { id, comesFrom } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield PatientListService.getVisitNoteById(id);
    const { status } = response;
    if (status) {
      const { visit } = response?.data;
      yield put(setVisitNoteCareFlowData(visit));
      if (comesFrom === "viewVisitNote") {
        yield put(setVisitPreviewDialog(true));
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setVisitNoteCareFlowData({}));
    yield put(setVisitPreviewDialog(false));

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH EMERGENCY CONTACT DATA API CALL HERE
function* patchEmergencyContactDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.patchEmergencyContactData(
      action?.payload?.patientId,
      action?.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseEmergencyContactDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseEmergencyContactDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH BASE CAMP (UNIT LEADER) DATA API CALL HERE
function* patchBaseCampDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.patchBaseCampData(
      action?.payload?.patientId,
      action?.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseBaseCampDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseBaseCampDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH EMERGENCY CONTACT DATA API CALL HERE
function* patchChiefComplaintDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.patchChiefComplaintData(
      action?.payload?.visitId,
      action?.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseChiefComplaintDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseChiefComplaintDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET CLINIC LOCATIONS API CALL FUNCTION
function* getAllMasterCodeAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.getAllMasterCode(
      action?.payload?.apiQuery
    );
    const { status } = response;
    if (status) {
      const { data } = response?.data;
      yield put(setMasterCodeData(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setMasterCodeData({}));

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST VISIT NOTE DATA ASYNC
function* postVisitNoteDataAsync(action) {
  const { apiPayload, comesFrom, navigate, patientId } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield PatientListService.postVisitNoteData(apiPayload);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      if (comesFrom !== "comesFromOrder") {
        eventEHRCustomToastMessage({
          title: `${message}`,
          status: "success",
        });
      }
      yield put(setUpdateVisitNoteDataOnceDraftNote(true));
      // Optional success-only callback (e.g. open the disposition dialog only
      // after the save actually succeeds). No-op when not provided.
      if (action?.payload?.onSuccess) {
        action.payload.onSuccess();
      }
      if (comesFrom === "dischargeButton" || comesFrom === "intervalNote") {
        navigate(`/patient/${patientId}?tab=visits`);
      }
    }
  } catch (error) {
    yield put(setUpdateVisitNoteDataOnceDraftNote(false));

    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH VISIT NOTE DATA ASYNC
function* patchVisitNoteDataAsync(action) {
  const { apiPayload, comesFrom, navigate, visitNoteId, patientId } =
    action?.payload;
  try {
    yield put(showLoader());
    const response = yield PatientListService.patchVisitNoteData(
      visitNoteId,
      apiPayload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      if (comesFrom !== "comesFromOrder") {
        eventEHRCustomToastMessage({
          title: `${message}`,
          status: "success",
        });
      }

      yield put(setUpdateVisitNoteDataOnceDraftNote(true));
      // Optional success-only callback (e.g. open the disposition dialog only
      // after the save actually succeeds). No-op when not provided.
      if (action?.payload?.onSuccess) {
        action.payload.onSuccess();
      }
      if (comesFrom === "dischargeButton" || comesFrom === "intervalNote") {
        navigate(`/patient/${patientId}?tab=visits`);
      } else if (comesFrom === "dashboard") {
        navigate(`/dashboard`);
        yield put(setClosePreviewDialog(true));
      } else if (comesFrom === "unsigned-visits") {
        yield put(setClosePreviewDialog(true));
      }
    }
  } catch (error) {
    yield put(setUpdateVisitNoteDataOnceDraftNote(false));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// SEND VISIT NOTE (email/sms) ASYNC
function* sendVisitNoteAsync(action) {
  const { apiPayload, visitNoteId, onSuccess } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield PatientListService.sendVisitNote(
      visitNoteId,
      apiPayload
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      if (onSuccess) {
        onSuccess();
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST ORDER DATA ASYNC
function* postOrderDataAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.postOrderData(action?.payload);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      console.log("data:", data);
      yield put(setCloseCreateOrderDialog(true));
      yield put(setOrderChange(true));
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    yield put(setOrderChange(false));

    yield put(setCloseCreateOrderDialog(false));

    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST TRANSFER PATIENT DATA ASYNC
function* postTransferPatientAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.postTransferPatient(
      action?.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const { disposition, message } = response?.data;
      yield put(setDispositionData(disposition));
      yield put(setCloseDispositionDialog(true));

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    yield put(setDispositionData({}));
    yield put(setCloseDispositionDialog(false));

    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST TRANSFER PATIENT DATA ASYNC
function* postTransferEMSPatientAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.postTransferEMSPatient(
      action?.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const { disposition, message } = response?.data;
      yield put(setDispositionData(disposition));
      yield put(setCloseDispositionDialog(true));

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    yield put(setDispositionData({}));
    yield put(setCloseDispositionDialog(false));

    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET DEPARTMENTS  API CALL FUNCTION
function* getDepartmentsAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.getDepartments(
      action?.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const { department } = response?.data;
      const departmentList = department?.map((data) => {
        return {
          label: data?.name,
          value: data?.id,
        };
      });
      yield put(setDepartmentData(departmentList));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setDepartmentData([]));

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH DISPOSITION DATA ASYNC
function* updateDispositionDataAsync(action) {
  const { apiPayload, navigate, dispositionId, patientId } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield PatientListService.updateDispositionData(
      dispositionId,
      apiPayload
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      navigate(`/patient/${patientId}?tab=visits`);
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE ORDER ITEM ASYNC
function* deleteOrderItemAsync(action) {
  const { orderId, comesFrom } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield PatientListService.deleteOrderItem(orderId);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      yield put(setUpdateVisitNoteDataOnceDraftNote(true));
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    yield put(setUpdateVisitNoteDataOnceDraftNote(false));

    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* getFacilitiesAsync(action) {
  try {
    yield put(showLoader());
    const isBaseCamp = action?.payload?.isBaseCamp;
    const first = yield PatientListService.getFacilities({
      isBaseCamp,
      pageNumber: 1,
      limit: 100,
    });
    if (first?.status) {
      let facilitys = first?.data?.facilitys ?? [];
      const totalPages = first?.data?.totalPages ?? 1;
      if (totalPages > 1) {
        const rest = yield Promise.all(
          Array.from({ length: totalPages - 1 }, (_, i) =>
            PatientListService.getFacilities({
              isBaseCamp,
              pageNumber: i + 2,
              limit: 100,
            }).then((r) => r?.data?.facilitys ?? [])
          )
        );
        facilitys = facilitys.concat(...rest);
      }
      yield put(setFacilityData(facilitys));
    }
  } catch (error) {
    yield put(setFacilityData([]));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* getRoomListAsync(action) {
  try {
    yield put(showLoader());
    const facilityId = action?.payload?.facilityId;
    const limit = 100;
    // Page through ALL rooms so the Room Assignment dropdown is never truncated.
    const first = yield PatientListService.getRooms({
      facilityId,
      pageNumber: 1,
      limit,
    });
    const { status } = first;
    if (status) {
      let rooms = first?.data?.rooms ?? [];
      const totalPages = first?.data?.totalPages ?? 1;
      if (totalPages > 1) {
        const rest = yield Promise.all(
          Array.from({ length: totalPages - 1 }, (_, i) =>
            PatientListService.getRooms({
              facilityId,
              pageNumber: i + 2,
              limit,
            }).then((r) => r?.data?.rooms ?? [])
          )
        );
        rooms = rooms.concat(...rest);
      }
      yield put(setRoomList(rooms));
    }
  } catch (error) {
    yield put(setRoomList([]));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* assignRoomAsync(action) {
  const { apiPayload, patientId } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield PatientListService.assignRoom(apiPayload);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      // Refresh the patient profile so the current room reflects the change.
      if (patientId) {
        yield put(getPatientProfileData(patientId));
      }
      yield put(setRefreshPatientList(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* getIncidentLocationsAsync() {
  try {
    yield put(showLoader());
    const first = yield PatientListService.getMasterDataByType({
      type: "incident_location",
      pageNumber: 1,
      limit: 100,
    });
    if (first?.status) {
      let rows = first?.data?.masterData ?? [];
      const totalPages = first?.data?.totalPages ?? 1;
      if (totalPages > 1) {
        const rest = yield Promise.all(
          Array.from({ length: totalPages - 1 }, (_, i) =>
            PatientListService.getMasterDataByType({
              type: "incident_location",
              pageNumber: i + 2,
              limit: 100,
            }).then((r) => r?.data?.masterData ?? [])
          )
        );
        rows = rows.concat(...rest);
      }
      yield put(setIncidentLocationData(rows));
    }
  } catch (error) {
    yield put(setIncidentLocationData([]));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* patchOrderVerifyAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.patchVerifyOrderStatus(
      action?.payload?.orderId,
      action?.payload?.payload
    );
    if (response?.status) {
      const message = response?.data?.message;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseVerifyOrderStatus(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseVerifyOrderStatus(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH EMERGENCY CONTACT DATA API CALL HERE
function* patchPatientAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.patchPatient(
      action?.payload?.id,
      action?.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setRefreshPatientList(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setRefreshPatientList(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// PATCH EMERGENCY CONTACT DATA API CALL HERE
function* postDataToJotFormAsync(action) {
  const { data, navigate } = action.payload;
  try {
    yield put(showLoader());
    const response = yield PatientListService.postDataToJotForm(data);
    const { status } = response;
    if (status) {
      const { message } = response?.data;

      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      navigate("/patient");
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    // yield put(setRefreshPatientList(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET TASK DATA ASYNC
function* getFacilityListAsync(action) {
  try {
    yield put(showLoader());
    const limit = 100;
    // Page through ALL facilities so JotForm's Transport Destination / off-site
    // facility dropdowns are never truncated by the page limit.
    const first = yield PatientListService.getFacilityList({
      pageNumber: 1,
      limit,
    });
    const { status, data } = first;
    if (status) {
      let facilitys = data?.facilitys ?? [];
      const totalPages = data?.totalPages ?? 1;
      if (totalPages > 1) {
        const rest = yield Promise.all(
          Array.from({ length: totalPages - 1 }, (_, i) =>
            PatientListService.getFacilityList({
              pageNumber: i + 2,
              limit,
            }).then((r) => r?.data?.facilitys ?? [])
          )
        );
        facilitys = facilitys.concat(...rest);
      }
      yield put(setFacilityList({ ...data, facilitys }));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setFacilityList({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* sendEmailAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.sendEmail(
      action?.payload?.apiPayload
    );
    const { status } = response;
    if (status) {
      const message = response?.data?.message || "Email sent successfully";
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      action?.payload?.onClose();
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseCreateTriageDrawer(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* sendSMSAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.sendSMS(
      action?.payload?.apiPayload
    );
    const { status } = response;
    console.log("response", response);

    if (status) {
      const message = response?.data?.message || "SMS sent successfully";
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      action?.payload?.onClose();
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseCreateTriageDrawer(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* getVisitNoteByIdForPreviewDischargeFormAsync(action) {
  try {
    yield put(showLoader());
    const response = yield PatientListService.getVisitNoteById(action?.payload);
    const { status } = response;
    if (status) {
      const visit = response?.data?.visit;
      yield put(setVisitNoteCareFlowDataForDischargePreview(visit));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setVisitNoteCareFlowDataForDischargePreview({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// POST BUNDLE ORDER ASYNC FUNCTION
function* postBundleOrderAsync(action) {
  try {
    yield put(showLoader());
    const response = yield BundleOrderService.createBundleOrder(
      action?.payload
    );
    const { status } = response;
    if (status) {
      const message =
        response?.data?.message || "Bundle order created successfully";
      eventEHRCustomToastMessage({
        title: message,
        status: "success",
      });

      // Trigger a callback or update state as needed
      if (action?.payload?.onSuccess) {
        action.payload.onSuccess(response?.data);
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message || "Failed to create bundle order"}`,
      status: "error",
    });

    if (action?.payload?.onError) {
      action.payload.onError(error);
    }
    console.log("Bundle order error: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET ALL ORDER NOTES ASYNC FUNCTION
function* getAllOrderNotesAsync(action) {
  try {
    yield put(showLoader());
    const response = yield NotesService.getAllOrderNotes(action?.payload);
    const { status } = response;
    if (status) {
      const apiData = response?.data;
      // You can dispatch to store the notes data
      // yield put(setOrderNotesData(apiData));
      
      // Trigger callback if provided
      if (action?.payload?.onSuccess) {
        action.payload.onSuccess(apiData);
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message || "Failed to fetch order notes"}`,
      status: "error",
    });
    
    if (action?.payload?.onError) {
      action.payload.onError(error);
    }
    console.log("Get order notes error: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET ORDER NOTE BY ID ASYNC FUNCTION
function* getOrderNoteByIdAsync(action) {
  try {
    yield put(showLoader());
    const response = yield NotesService.getOrderNoteById(action?.payload?.noteId);
    const { status } = response;
    if (status) {
      const { data } = response?.data;
      
      // Trigger callback if provided
      if (action?.payload?.onSuccess) {
        action.payload.onSuccess(data);
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message || "Failed to fetch order note"}`,
      status: "error",
    });
    
    if (action?.payload?.onError) {
      action.payload.onError(error);
    }
    console.log("Get order note error: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// CREATE ORDER NOTE ASYNC FUNCTION
function* createOrderNoteAsync(action) {
  try {
    yield put(showLoader());
    const response = yield NotesService.createOrderNote(
      action?.payload?.orderId,
      action?.payload?.noteData
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      eventEHRCustomToastMessage({
        title: message || "Order note created successfully",
        status: "success",
      });
      
      // Trigger callback if provided
      if (action?.payload?.onSuccess) {
        action.payload.onSuccess(data);
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message || "Failed to create order note"}`,
      status: "error",
    });
    
    if (action?.payload?.onError) {
      action.payload.onError(error);
    }
    console.log("Create order note error: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// UPDATE ORDER NOTE ASYNC FUNCTION
function* updateOrderNoteAsync(action) {
  try {
    yield put(showLoader());
    const response = yield NotesService.updateOrderNote(
      action?.payload?.noteId,
      action?.payload?.noteData
    );
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      eventEHRCustomToastMessage({
        title: message || "Order note updated successfully",
        status: "success",
      });
      
      // Trigger callback if provided
      if (action?.payload?.onSuccess) {
        action.payload.onSuccess(data);
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message || "Failed to update order note"}`,
      status: "error",
    });
    
    if (action?.payload?.onError) {
      action.payload.onError(error);
    }
    console.log("Update order note error: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE ORDER NOTE ASYNC FUNCTION
function* deleteOrderNoteAsync(action) {
  try {
    yield put(showLoader());
    const response = yield NotesService.deleteOrderNote(action?.payload?.noteId);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: message || "Order note deleted successfully",
        status: "success",
      });
      
      // Trigger callback if provided
      if (action?.payload?.onSuccess) {
        action.payload.onSuccess();
      }
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message || "Failed to delete order note"}`,
      status: "error",
    });
    
    if (action?.payload?.onError) {
      action.payload.onError(error);
    }
    console.log("Delete order note error: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET PATIENT DOCUMENTS API CALL FUNCTION
function* getPatientDocumentsAsync(action) {
  try {
    yield put(showLoader());
    const { patientId, name } = action.payload;
    const response = yield PatientListService.getPatientDocuments(patientId, {
      name,
    });
    const { status } = response;
    if (status) {
      yield put(setTableDataForDocumentsTab(response?.data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// UPLOAD PATIENT DOCUMENT API CALL FUNCTION
function* uploadPatientDocumentAsync(action) {
  try {
    yield put(showLoader());
    const { data } = action.payload;
    const response = yield PatientListService.uploadPatientDocument(data);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: message || "Document uploaded successfully",
        status: "success",
      });
      yield put(setCloseUploadDocumentDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE PATIENT DOCUMENT API CALL FUNCTION
function* deletePatientDocumentAsync(action) {
  try {
    yield put(showLoader());
    const { documentId } = action.payload;
    const response = yield PatientListService.deletePatientDocument(
      documentId
    );
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: message || "Document deleted successfully",
        status: "success",
      });
      yield put(setCloseUploadDocumentDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}


function* deleteVisitAsync(action) {
  try {
    yield put(showLoader());
    const { visitId } = action.payload;
    const response = yield PatientListService.deleteVisit(visitId);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: message || "Visit deleted successfully",
        status: "success",
      });
      // Refresh patient profile (and, via its dependency, the visit list).
      yield put(setRefreshPatientList(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([takeLatest(searchParticipants().type, searchParticipantsAsync)]);
  yield all([takeLatest(createNewPatient().type, createNewPatientAsync)]);
  yield all([takeLatest(getPatientList().type, getPatientListAsync)]);
  yield all([takeLatest(createNewVisit().type, createNewVisitAsync)]);
  yield all([takeLatest(createEMSVisit().type, createEMSVisitAsync)]);

  yield all([takeLatest(getClinicLocations().type, getClinicLocationsAsync)]);
  yield all([
    takeLatest(
      convertParticipantToPatient().type,
      convertParticipantToPatientAsync
    ),
  ]);
  yield all([
    takeLatest(convertPartToPatient().type, convertPartToPatientAsync),
  ]);
  yield all([
    takeLatest(getPatientProfileData().type, getPatientProfileDataAsync),
  ]);
  yield all([
    takeLatest(
      patchPatientProfileDetailsData().type,
      patchPatientProfileDetailsDataAsync
    ),
  ]);
  yield all([takeLatest(createTriage().type, createTriageAsync)]);
  yield all([
    takeLatest(
      getPatientDetailsDataByTabWise().type,
      getPatientDetailsDataByTabWiseAsync
    ),
  ]);
  yield all([takeLatest(getVisitNoteById().type, getVisitNoteByIdAsync)]);
  yield all([
    takeLatest(
      patchEmergencyContactData().type,
      patchEmergencyContactDataAsync
    ),
  ]);
  yield all([
    takeLatest(patchBaseCampData().type, patchBaseCampDataAsync),
  ]);
  yield all([
    takeLatest(patchChiefComplaintData().type, patchChiefComplaintDataAsync),
  ]);
  yield all([takeLatest(getAllMasterCode().type, getAllMasterCodeAsync)]);

  yield all([takeLatest(postVisitNoteData().type, postVisitNoteDataAsync)]);
  yield all([takeLatest(patchVisitNoteData().type, patchVisitNoteDataAsync)]);
  yield all([takeLatest(sendVisitNote().type, sendVisitNoteAsync)]);
  yield all([takeLatest(postOrderData().type, postOrderDataAsync)]);
  yield all([takeLatest(getDepartments().type, getDepartmentsAsync)]);
  yield all([
    takeLatest(postTransferEMSPatient().type, postTransferEMSPatientAsync),
  ]);
  yield all([
    takeLatest(updateDispositionData().type, updateDispositionDataAsync),
  ]);
  yield all([takeLatest(deleteOrderItem().type, deleteOrderItemAsync)]);
  yield all([takeLatest(getFacilities().type, getFacilitiesAsync)]);
  yield all([takeLatest(getRoomList().type, getRoomListAsync)]);
  yield all([takeLatest(assignRoom().type, assignRoomAsync)]);
  yield all([
    takeLatest(getIncidentLocations().type, getIncidentLocationsAsync),
  ]);
  yield all([takeLatest(patchVerifyOrder().type, patchOrderVerifyAsync)]);
  yield all([takeLatest(patchPatient().type, patchPatientAsync)]);
  yield all([takeLatest(postTransferPatient().type, postTransferPatientAsync)]);
  yield all([takeLatest(postBundleOrder().type, postBundleOrderAsync)]);
  yield all([takeLatest(postDataToJotForm().type, postDataToJotFormAsync)]);
  yield all([takeLatest(getFacilityList().type, getFacilityListAsync)]);
  yield all([takeLatest(sendEmail().type, sendEmailAsync)]);
  yield all([takeLatest(sendSMS().type, sendSMSAsync)]);

  yield all([
    takeLatest(
      getVisitNoteByIdForPreviewDischargeForm().type,
      getVisitNoteByIdForPreviewDischargeFormAsync
    ),
  ]);
  
  // Order Notes saga listeners
  yield all([takeLatest(getAllOrderNotes().type, getAllOrderNotesAsync)]);
  yield all([takeLatest(getOrderNoteById().type, getOrderNoteByIdAsync)]);
  yield all([takeLatest(createOrderNote().type, createOrderNoteAsync)]);
  yield all([takeLatest(updateOrderNote().type, updateOrderNoteAsync)]);
  yield all([takeLatest(deleteOrderNote().type, deleteOrderNoteAsync)]);

  // Document saga listeners
  yield all([takeLatest(getPatientDocuments().type, getPatientDocumentsAsync)]);
  yield all([takeLatest(uploadPatientDocument().type, uploadPatientDocumentAsync)]);
  yield all([takeLatest(deletePatientDocument().type, deletePatientDocumentAsync)]);
  yield all([takeLatest(deleteVisit().type, deleteVisitAsync)]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
